import { combineReducers } from "redux";
import { CompanyTypes } from "../../action_types";
import {
  arrayToObject,
  removeItem,
  insertItem,
  updateObjectInArray,
} from "@app/utils/helpers";

function all(state = {}, action) {
  switch (action.type) {
    case CompanyTypes.GET_COMPANIES_SUCCESS:
      return { ...state, ...arrayToObject(action.data) };
    case CompanyTypes.GET_COMPANY_SUCCESS:
    case CompanyTypes.CREATE_COMPANY_SUCCESS:
    case CompanyTypes.UPDATE_COMPANY_SUCCESS:
      return {
        ...state,
        [action.data.id]: action.data,
      };
    case CompanyTypes.DELETE_COMPANY_SUCCESS:
      const { [action.id]: _, ...newState } = state;
      return newState;
    default:
      return state;
  }
}

function ui(state = [], action) {
  switch (action.type) {
    case CompanyTypes.GET_COMPANIES_SUCCESS:
      return action.data;
    case CompanyTypes.CREATE_COMPANY_SUCCESS:
      return insertItem(state, action.data);
    case CompanyTypes.UPDATE_COMPANY_SUCCESS:
      return updateObjectInArray(state, action.data);
    case CompanyTypes.DELETE_COMPANY_SUCCESS:
      return removeItem(state, action.id);
    default:
      return state;
  }
}

export default combineReducers({
  all,
  ui,
});
